var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMecLogowithouttext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "595.276pt",
    height: "595.276pt",
    viewBox: "0 0 595.276 595.276",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_0"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,595.276)",
    d: "M0 595.276H595.276V0H0Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer_1",
    "data-name": ""
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,48.713,304.0732)",
    d: "M0 0H45.129L84.785-31.615 124.44 0H169.57V-159.542H125.582V-54.06L84.436-86.756 43.533-54.516V-159.542H0Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,246.5441,304.0732)",
    d: "M0 0H128.089V-37.608H43.533V-61.766H120.112V-96.637H43.533V-121.936H129.229V-159.542H0Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_0)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,475.37,466.80659)",
    d: "M0 0C-11.395 0-22.11 2.052-32.137 6.155-42.164 10.257-50.865 15.991-58.234 23.363-65.604 30.731-71.453 39.466-75.784 49.573-80.114 59.676-82.28 70.654-82.28 82.506V82.963C-82.28 94.508-80.152 105.334-75.898 115.44-71.645 125.543-65.794 134.358-58.346 141.878-50.905 149.401-42.052 155.287-31.796 159.542-21.539 163.794-10.335 165.924 1.822 165.924 10.027 165.924 17.471 165.126 24.158 163.531 30.842 161.936 36.959 159.655 42.506 156.693 48.05 153.73 53.066 150.198 57.549 146.094 62.027 141.993 66.017 137.51 69.512 132.648L36.239 106.894C31.679 112.667 26.665 117.224 21.196 120.568 15.726 123.91 9.115 125.583 1.368 125.583-4.256 125.583-9.384 124.478-14.017 122.278-18.655 120.073-22.645 117.072-25.982 113.276-29.326 109.475-31.948 104.992-33.846 99.829-35.747 94.661-36.695 89.191-36.695 83.418V82.963C-36.695 77.036-35.747 71.454-33.846 66.21-31.948 60.969-29.326 56.446-25.982 52.65-22.645 48.849-18.655 45.847-14.017 43.646-9.384 41.443-4.256 40.343 1.368 40.343 5.468 40.343 9.23 40.797 12.649 41.709 16.067 42.621 19.18 43.95 21.993 45.699 24.804 47.442 27.463 49.494 29.97 51.852 32.478 54.206 34.946 56.827 37.378 59.715L70.653 36.011C66.854 30.845 62.712 26.058 58.232 21.653 53.749 17.245 48.658 13.449 42.962 10.257 37.263 7.066 30.881 4.559 23.815 2.735 16.75 .913 8.809 0 0 0",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,389.5569,289.1488)",
    d: "M0 0V-15.583L18.888-1.241 0-18.335V-48.296C.623-47.141 1.397-45.748 1.397-45.748 24.394-2.595 71.456 3.049 77.604 3.609L23.456 57.758-61.178 0Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,251.3432,289.1488)",
    d: "M0 0 46.686 30.122 16.904 0H69.72L128.381 41.715 69.66 99.417V119.219L128.381 148.578 69.66 177.941V178.858H65.989V100.166L-59.699 0Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,465.2635,354.19819)",
    d: "M0 0V-59.291L58.932-29.283Z",
    fill: "#ffffff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMecLogowithouttext);
export default __webpack_public_path__ + "static/media/MEC Logo without text.99bbd852c6e49a428e3328dd631202ef.svg";
export { ForwardRef as ReactComponent };